import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FlagService } from '../../flag/flag.service';
import { SettingService } from '../../setting/setting.service';
import { Inspection } from '../../shared/interfaces';
import { MergeAnswersService } from '../../shared/merge.answers.service';
import { permissions } from '../../shared/permissions';
import { UserService } from '../../user/user.service';

@Component({
  selector: 'app-review-navigation',
  templateUrl: './review.navigation.component.html',
  styleUrls: ['./review.navigation.component.scss'],
})
// tslint:disable:forin
export class ReviewNavigationComponent implements OnChanges, OnInit {
  canOpenFlagManager = false;
  flags: {
    id: number;
    name: string;
    subtypes: number[];
  }[] = [];

  get shortcut() {
    for (const key in this.shortcuts) {
      let items = this.filters.items;
      if (this.items && this.filters.items && this.items.length === this.filters.items.length) {
        items = [];
      }
      let sections = this.filters.sections;
      if (this.sections && this.filters.sections && this.sections.length === this.filters.sections.length) {
        sections = [];
      }
      let questionTags = this.filters.questionTags;
      if (
        this.questionTags &&
        this.filters.questionTags &&
        this.questionTags.length === this.filters.questionTags.length
      ) {
        questionTags = [];
      }
      if (
        this.shortcuts[key] ===
        JSON.stringify({
          ...this.filters,
          items,
          sections,
          questionTags,
        })
      ) {
        return key;
      }
    }

    return '';
  }

  set shortcut(x) {
    this.applyShortcut(x);
  }

  @Input() inspection: Inspection;
  @Input() answers: any[];
  @Input() currentView: string;
  @Input() isPopupOpen = false;
  @Input() isRecLetterSend = { value: false };
  @Output() action = new EventEmitter<ReviewNavigationAction>();
  @Output() filterChange = new EventEmitter<InspectionFilters>();

  items;
  sections;
  questionTags;
  flagsProgress = 0;
  searchedItems = [];
  searchedSections = [];
  searchedQuestionTags = [];
  showOtherFilters = false;
  allowDualMonitor = false;
  scoresEnabled = true;
  open = false;
  pannel: 'main' | 'filters' = 'main';
  nActiveFilters = 0;
  filters: InspectionFilters = {
    sorting: 'followConfigurationOrder',
    items: [],
    sections: [],
    questionTags: [],
    questions: 'all',
    flags: 'all',
    withoutComments: true,
    accepted: true,
    rejected: true,
    unreviewed: true,
    withoutFlags: true,
    withAnswers: true,
    withDeadlineExtension: false,
  };

  shortcuts = {
    'all-questions': JSON.stringify({
      sorting: 'followConfigurationOrder',
      items: [],
      sections: [],
      questionTags: [],
      questions: 'all',
      flags: 'all',
      withoutComments: true,
      accepted: true,
      rejected: true,
      unreviewed: true,
      withoutFlags: true,
      withAnswers: true,
      withDeadlineExtension: false,
    }),

    'all-mandatory-or-scored': JSON.stringify({
      sorting: 'followConfigurationOrder',
      items: [],
      sections: [],
      questionTags: [],
      questions: 'mandatoryOrScored',
      flags: 'all',
      withoutComments: true,
      accepted: true,
      rejected: true,
      unreviewed: true,
      withoutFlags: true,
      withAnswers: true,
      withDeadlineExtension: false,
    }),

    'all-flagged': JSON.stringify({
      sorting: 'followConfigurationOrder',
      items: [],
      sections: [],
      questionTags: [],
      questions: 'all',
      flags: 'all',
      withoutComments: true,
      accepted: true,
      rejected: true,
      unreviewed: true,
      withoutFlags: false,
      withAnswers: true,
      withDeadlineExtension: false,
    }),

    'auto-scored': JSON.stringify({
      sorting: 'followConfigurationOrder',
      items: [],
      sections: [],
      questionTags: [],
      questions: 'autoScored',
      flags: 'all',
      withoutComments: true,
      accepted: true,
      rejected: true,
      unreviewed: true,
      withoutFlags: true,
      withAnswers: true,
      withDeadlineExtension: false,
    }),

    'all-unreviewed': JSON.stringify({
      sorting: 'followConfigurationOrder',
      items: [],
      sections: [],
      questionTags: [],
      questions: 'all',
      flags: 'all',
      withoutComments: true,
      accepted: false,
      rejected: false,
      unreviewed: true,
      withoutFlags: true,
      withAnswers: true,
      withDeadlineExtension: false,
    }),

    'all-rejected': JSON.stringify({
      sorting: 'followConfigurationOrder',
      items: [],
      sections: [],
      questionTags: [],
      questions: 'all',
      flags: 'all',
      withoutComments: true,
      accepted: false,
      rejected: true,
      unreviewed: false,
      withoutFlags: true,
      withAnswers: true,
      withDeadlineExtension: false,
    }),

    'all-unanswered': JSON.stringify({
      sorting: 'followConfigurationOrder',
      items: [],
      sections: [],
      questionTags: [],
      questions: 'all',
      flags: 'all',
      withoutComments: true,
      accepted: true,
      rejected: true,
      unreviewed: true,
      withoutFlags: true,
      withAnswers: false,
      withDeadlineExtension: false,
    }),

    'only-with-extension': JSON.stringify({
      sorting: 'followConfigurationOrder',
      items: [],
      sections: [],
      questionTags: [],
      questions: 'all',
      flags: 'all',
      withoutComments: true,
      accepted: true,
      rejected: true,
      unreviewed: true,
      withoutFlags: false,
      withAnswers: true,
      withDeadlineExtension: true,
    }),
  };

  hasLocations = false;
  hasPictures = false;

  constructor(
    private settingService: SettingService,
    private flagService: FlagService,
    private userService: UserService,
    private mergeAnswersService: MergeAnswersService,
  ) {}

  async ngOnInit() {
    this.scoresEnabled = await this.settingService.scoresEnabled();
    this.canOpenFlagManager = await this.userService.hasPermissions([permissions.FLAG.MANAGER]);
    const flags = await this.flagService.listTypes();
    const filteredFlags = flags.filter(type => type.name !== 'Legacy');
    for (const flag of filteredFlags) {
      this.flags.push({
        id: flag.id,
        name: flag.name,
        subtypes: flag.subtypes.map(subtype => subtype.id),
      });
    }
  }

  async ngOnChanges(changes: SimpleChanges) {
    if ('currentView' in changes) {
      this.allowDualMonitor = this.currentView === 'main' || this.currentView === 'gallery';

      if (this.currentView === 'flagManager') {
        this.shortcut = 'all-flagged';
      } else if (this.currentView !== 'flagManager' && this.shortcut === 'only-with-extension') {
        this.shortcut = 'all-flagged';
      }
    }

    if (this.answers && this.inspection) {
      this.items = [...(await this.mergeAnswersService.loadItems(this.inspection, this.answers))];
      this.flagsProgress = this.getFlagsProgress();
      this.selectAllItemsSections(this.filters.items);
      this.selectAllQuestionTags(this.filters.questionTags);
      this.applyFilters();
    }

    if ('answers' in changes && this.answers) {
      this.hasLocations = this.answers.some(a => a.location);
      this.hasPictures = this.answers.some(a => a.pictures);
    }
  }

  toggle() {
    this.open = !this.open;
  }

  isFlagTypeDisabled(): boolean {
    return (
      this.currentView === 'flagManager' && (this.shortcut === 'auto-scored' || this.filters.withDeadlineExtension)
    );
  }

  dualMonitor() {
    this.action.emit(ReviewNavigationAction.DUAL_MONITOR);
    this.isPopupOpen = true;
    this.open = false;
  }

  createOutput() {
    this.action.emit(ReviewNavigationAction.CREATE_OUTPUT);
    this.open = false;
  }

  createLetter() {
    this.action.emit(ReviewNavigationAction.CREATE_LETTER);
    this.open = false;
  }

  applyShortcut(key) {
    switch (key) {
      case 'all-questions':
      case 'all-mandatory-or-scored':
      case 'all-flagged':
      case 'all-unreviewed':
      case 'all-rejected':
      case 'auto-scored':
      case 'all-unanswered':
      case 'only-with-extension':
        this.filters = JSON.parse(this.shortcuts[key]);
        break;

      default:
        return;
    }

    this.selectAllItemsSections(this.filters.items);
    this.selectQuestionTags();
  }

  applyFilters() {
    this.filterChange.emit({ ...this.filters });
    let count = 0;

    if (!this.filters.accepted) {
      count++;
    }
    if (!this.filters.rejected) {
      count++;
    }
    if (!this.filters.unreviewed) {
      count++;
    }
    if (!this.filters.withoutComments) {
      count++;
    }
    if (!this.filters.withoutFlags) {
      count++;
    }
    if (!this.filters.withAnswers) {
      count++;
    }
    if (this.filters.questions !== 'all') {
      count++;
    }
    if (this.filters.items && this.items && this.filters.items.length !== this.items.length) {
      count++;
    }
    if (this.filters.sections && this.sections && this.filters.sections.length !== this.sections.length) {
      count++;
    }
    if (
      this.filters.questionTags &&
      this.questionTags &&
      this.filters.questionTags.length !== this.questionTags.length
    ) {
      count++;
    }
    if (this.filters.flags !== 'all') {
      count++;
    }
    if (this.filters.sorting !== 'followConfigurationOrder') {
      count++;
    }
    if (this.filters.withDeadlineExtension) {
      count++;
    }

    this.nActiveFilters = count;

    this.open = false;
  }

  detailChanged() {
    this.shortcut = '';
  }

  selectAllItemsSections(changedItems: any) {
    if (changedItems.length === 0) {
      this.selectAllItems();
      if (this.items) {
        // Refresh section list
        this.sections = this.items
          .filter(item => changedItems.length === 0 || changedItems.includes(item.label))
          .reduce(
            (sections: any[], item) => [
              ...sections,
              // ignore duplicates
              ...item.sections.filter(section => !sections.find(s => s.id === section.id)),
            ],
            [],
          );
        this.sections = this.sections.filter(section => section.questionsHasAnswer);

        // reset selected sections
        this.selectAllSections();
      }
    }

    if (this.items) {
      for (const item of this.items) {
        item['allItemsGroup'] = 'allItemsGroup';
      }
    }
  }

  selectAllQuestionTags(changedQuestionTags: any) {
    if (changedQuestionTags.length === 0) {
      this.selectQuestionTags();
      if (this.questionTags) {
        this.selectQuestionTags();
      }
    }
    if (this.questionTags) {
      for (const tag of this.questionTags) {
        tag['allQuestionTagsGroup'] = 'allQuestionTagsGroup';
      }
    }
  }

  itemChanged(changedItems: any) {
    if (this.items) {
      // Refresh section list
      this.sections = this.items
        .filter(item => changedItems.includes(item.label))
        .reduce(
          (sections: any[], item) => [
            ...sections,
            // ignore duplicates
            ...item.sections.filter(section => !sections.find(s => s.id === section.id)),
          ],
          [],
        );
      this.sections = this.sections.filter(section => section.questionsHasAnswer);

      this.selectAllSections();
    }
  }

  sectionChanged() {
    // If none is selected, add "all"
    if (this.filters.sections.length === 0) {
      this.selectAllSections();
    }
  }

  questionTagsChanged() {
    // If none is selected, add "all"
    if (this.filters.questionTags.length === 0) {
      this.selectQuestionTags();
    }
  }

  clearFilters() {
    this.shortcut = 'all-questions';
    this.applyFilters();
  }

  getFlagsProgress() {
    const allFlags = this.answers.reduce((flags, ans) => {
      flags.push(...(ans.flags || []));
      return flags;
    }, []);

    const includedFlags = allFlags.filter(f => f.ignore !== true && f.groupId != null);
    const completed = includedFlags.filter(f => this.flagService.isFilled(f));

    if (includedFlags.length === 0) {
      return 100;
    }

    return Math.round((completed.length / includedFlags.length) * 100) || 0;
  }

  selectAllItems() {
    if (!this.items) {
      return;
    }
    const allSelect = items => {
      const changedItems = [];
      for (const item of items) {
        item['allItemsGroup'] = 'allItemsGroup';
        changedItems.push(item.label);
      }
      this.filters.items = [...changedItems];
    };
    allSelect(this.items);
  }

  selectAllSections() {
    if (!this.sections) {
      return;
    }
    const allSelect = sections => {
      const changedSections = [];
      for (const section of sections) {
        section['allSectionsGroup'] = 'allSectionsGroup';
        changedSections.push(section.id);
      }
      this.filters.sections = [...changedSections];
    };
    allSelect(this.sections);
  }

  selectQuestionTags() {
    if (!this.items) {
      return;
    }
    this.questionTags = [
      ...new Set(
        this.items
          .flatMap(item => item.sections)
          .filter(section => section.questionsHasAnswer)
          .flatMap(section => section.questions)
          .flatMap(question => question.questionTags)
          .reduce((uniqueTags, tag) => {
            const existingTag = uniqueTags.find(t => t.id === tag.id);
            if (!existingTag) {
              tag['allQuestionTagsGroup'] = 'allQuestionTagsGroup';
              uniqueTags.push(tag);
            }
            return uniqueTags;
          }, []),
      ),
    ];
    this.questionTags.unshift({ id: 0, name: 'No Question Tag' });

    if (!this.questionTags) {
      return;
    }

    const allSelect = tags => {
      const changedTags = [];
      for (const tag of tags) {
        tag['allQuestionTagsGroup'] = 'allQuestionTagsGroup';
        changedTags.push(tag.id);
      }
      this.filters.questionTags = [...changedTags];
    };
    allSelect(this.questionTags);
  }

  onSearchItems(data: any) {
    if (data.term === '') {
      this.searchedItems = [];
    } else {
      this.searchedItems = data.items;
    }
  }

  onEnterItems() {
    if (this.searchedItems.length > 0) {
      for (const item of this.searchedItems) {
        // Ignore Select All
        if (Object.keys(item).length === 1) {
          continue;
        }
        if (this.filters.items.includes(item.label)) {
          this.filters.items = this.filters.items.filter(i => i !== item.label);
        } else {
          this.filters.items = [...this.filters.items, item.label];
        }
        this.itemChanged(this.filters.items);
      }
    }
  }

  onSearchSections(data: any) {
    if (data.term === '') {
      this.searchedSections = [];
    } else {
      this.searchedSections = data.items;
    }
  }

  onEnterSections() {
    if (this.searchedSections.length > 0) {
      for (const section of this.searchedSections) {
        // Ignore Select All
        if (Object.keys(section).length === 1) {
          continue;
        }
        if (this.filters.sections.includes(section.id)) {
          this.filters.sections = this.filters.sections.filter(i => i !== section.id);
        } else {
          this.filters.sections = [...this.filters.sections, section.id];
        }
      }
    }
  }

  onSearchQuestionTags(data: any) {
    if (data.term === '') {
      this.searchedQuestionTags = [];
    } else {
      this.searchedQuestionTags = data.items;
    }
  }

  onEnterQuestionTags() {
    if (this.searchedQuestionTags.length > 0) {
      for (const tag of this.searchedQuestionTags) {
        // Ignore Select All
        if (Object.keys(tag).length === 1) {
          continue;
        }
        if (this.filters.questionTags.includes(tag.id)) {
          this.filters.questionTags = this.filters.questionTags.filter(i => i !== tag.id);
        } else {
          this.filters.questionTags = [...this.filters.questionTags, tag.id];
        }
      }
    }
  }
}

export enum ReviewNavigationAction {
  DUAL_MONITOR,
  CREATE_OUTPUT,
  CREATE_LETTER,
}

export interface InspectionFilters {
  sorting: 'followConfigurationOrder' | 'asc' | 'desc';
  items: any[];
  sections: number[];
  questionTags: any[];
  questions: 'all' | 'mandatoryOrScored' | 'mandatory' | 'scored' | 'autoScored';
  flags: 'all' | number[];
  withoutComments: boolean;
  accepted: boolean;
  rejected: boolean;
  unreviewed: boolean;
  withoutFlags: boolean;
  withAnswers: boolean;
  withDeadlineExtension: boolean;
}
